import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { IOnboardingGuideStep } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding';

@Component({
    selector: 'fi-quiz-settings-sharing-guide-card',
    templateUrl: './fi-quiz-settings-sharing-guide-card.component.html',
    styleUrls: ['./fi-quiz-settings-sharing-guide-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-quiz-settings-sharing-guide-card' },
    standalone: false,
})
export class FiQuizSettingsSharingGuideCardComponent {
    protected readonly sharingSteps: IOnboardingGuideStep[] = [
        {
            Name: 'settings.pass_threshold',
            Description: 'quiz.pass_threshold_guide_description',
        },
        {
            Name: 'settings.retake_options',
            Description: 'quiz.retake_options_guide_description',
        },
        {
            Name: 'quiz.send_notification_failed_quiz',
            Description: 'quiz.send_notification_failed_quiz_guide_description',
        },
        {
            Name: 'settings.set_timer',
            Description: 'quiz.set_timer_guide_description',
        },
        {
            Name: 'common.sharing_selection',
            Description: 'quiz.sharing_selection_guide_description',
        },
    ];
}
